import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const SkltnCourse = () => {
    return (
        Array.from(Array(12).keys()).map(info =>
            <div className="item-education" >
                <div className={`pic`}>
                    <Skeleton animation="wave" variant="rect" width={100 + '%'} height={130} />
                </div>
                <div className="detaile">
                    <Skeleton animation="wave" variant="rect" width={100 + '%'} height={22} />
                    <Skeleton animation="wave" variant="rect" width={60 + '%'} height={22} />
                </div>
            </div>
        )
    );
}

export default SkltnCourse;